import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function createAssetView(state = initialState.isCSVUploadViewLoaded, action) {
	// avoiding state mutation, while updating nested states.
	switch (action.type) {
		case types.TOGGLE_CREATE_ASSET_MANUALENTRY_CSVUPLOAD_VIEW:
			return action.data;
		default:
			return state;
	}
}
